import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c41a6d34"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_item_group = _resolveComponent("a-menu-item-group")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_page_header = _resolveComponent("a-page-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_page_header, {
      onClick: _ctx.goToDashboard,
      style: {"border":"1px solid rgb(235, 237, 240)"},
      class: "pointer",
      title: "Patient Profile Management"
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_menu, { mode: "horizontal" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_sub_menu, null, {
              icon: _withCtx(() => [
                _createVNode(_component_SettingOutlined)
              ]),
              title: _withCtx(() => [
                _hoisted_1
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item_group, { title: "Actions" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_3
  ], 64))
}